import React from 'react';
import { BsFolder } from '@react-icons/all-files/bs/BsFolder';

import { decorateComponent } from '../../documentComponents';
import { Tab } from './Tab';
import { TabInspector } from './Tab.Inspector';

export default decorateComponent(Tab, 'block', {
  id: 'tab',
  label: '탭',
  defaultProps: {
    buttonColumn: 2,
  },
  allowedChildren: ['tabItem'],
  disallowedAncestors: [
    'a',
    'coupon',
    'tabButton',
    'carousel',
    'tab',
  ],
  renderIcon: () => <BsFolder />,
  renderInspector: TabInspector,
});
